module.exports = __webpack_public_path__ + "static/img/tuomasi.aebef96f.jpg";